import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Geannuleerd',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Ontvangen',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Bevestigd',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'In bereiding',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'Onderweg',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Klaar',
  served: 'Geserveerd',
  status: {
    actual: 'Huidig',
    pending: 'In afwachting',
  },
  warning_label: {
    pickup_time_changed: '{{company}} heeft de tijd gewijzigd van {{initialTime}} naar {{currentTime}}',
  },
  labels: {
    order_number: 'Bestelnr.: {{number}}',
    today: 'Vandaag',
  },
};
